// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2-uZX","disabled":"FileBtn_disabled__2rmLS","warn":"FileBtn_warn__1qBYX","fade":"FileBtn_fade__tgXcy"};